
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import MDButton from 'components/MDButton';
import Select from 'react-select';
import MDInput from "components/MDInput";
import React, { useState, useEffect } from "react";
// import { useParams } from 'react-router-dom';
import { Oval } from 'react-loader-spinner';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import * as moment from 'moment';
import { Radio } from '@mui/material';
import * as service from '../../services/service';

function InternalMaterialRequisitions() {
    const [state, setState] = useState({ quantity: '', remarks: '', search: '', materials: '' });
    const [requisitionDate, setRequisitionDate] = useState(new Date());
    const [allocationData, setAllocationData] = useState([]);
    const [requisitionData, setRequisitionData] = useState([]);
    const [subAssemblyMaterialData, setSubAssemblyMaterialData] = useState([]);
    const [customerData, setCustomerData] = useState([]);
    const [workOrderData, setWorkOrderData] = useState([]);
    const [employeeData, setEmployeeData] = useState([]);
    const [customerId, setCustomerId] = useState('');
    const [workOrderId, setWorkOrderId] = useState('');
    const [employeeId, setEmployeeId] = useState('');
    const [stockId, setStockId] = useState('');
    const [productId, setProductId] = useState('');
    const [subAssemblyId, setSubAssemblyId] = useState('');
    const [partId, setPartId] = useState('');
    const [commonPartId, setCommonPartId] = useState('');
    const [materialCategoryData, setMaterialCategoryData] = useState([]);
    const [materialSubCategoryData, setMaterialSubCategoryData] = useState([]);
    const [materialData, setMaterialData] = useState([]);
    const [materialCategoryId, setMaterialCategoryId] = useState('');
    const [materialSubCategoryId, setMaterialSubCategoryId] = useState('');
    const [materialId, setMaterialId] = useState('');
    const [availableQtyData, setAvailableQtyData] = useState([]);
    const [materialIdForWO, setMaterialIdForWO] = useState('');
    const [productCatData, setProductCatData] = useState([]);
    const [productSubCatData, setProductSubCatData] = useState([]);
    const [productData, setProductData] = useState([]);
    const [productCatId, setProductCatId] = useState('');
    const [productSubCatId, setProductSubCatId] = useState('');
    const [productIdForOP, setProductIdForOP] = useState('');
    const [subAssemblyIdForOP, setSubAssemblyIdForOP] = useState('');
    const [partIdForOP, setPartIdForOP] = useState('');
    const [commonPartIdForOP, setCommonPartIdForOP] = useState('');
    const [subAssemblyData, setSubAssemblyData] = useState([]);
    const [partData, setPartData] = useState([]);
    const [commonPartData, setCommonPartData] = useState([]);

    const [issueFor, setIssueFor] = useState('');
    const [errors, setErrors] = useState({});
    const [loading, setLoading] = useState(false);
    const selectStyles = { menu: styles => ({ ...styles, zIndex: 999 }) };
    const issueForData = [{ label: 'Work Order', value: 'Work Order' }, { label: 'Office Purpose', value: 'Office Purpose' }]

    const getCustomers = () => {
        fetch(
            service.CUSTOMER_URL,
            {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
            })
            .then(res => res.json())
            .then(result => {
                const data2 = result.map((item) => ({ value: item.customerId, label: item.customerName }));
                setCustomerData(data2);
            });
    };

    const getWorkOrders = (id) => {
        fetch(
            service.GET_PENDING_WORK_ORDER,
            {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    CustomerId: id,
                })
            })
            .then(res => res.json())
            .then(result => {
                const data2 = result.map((item) => ({ value: item.workOrderId, label: item.jobNo }));
                setWorkOrderData(data2);
            });
    };

    const getStock = (id) => {
        const errs = {};
        fetch(
            service.GET_REQUIRED_STOCK,
            {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    WorkOrderId: id,
                })
            })
            .then(res => res.json())
            .then(result => {
                if (result[0].message.messageType === "Success") {
                    setAllocationData(result);
                }
                else {
                    errs[".noreqdata"] = result[0].message.message;
                    setErrors(errs);
                }
            })
            .catch(err => {
                if (err) {
                    setErrors(err);
                };
            });
    };

    const getMaterialCategories = () => {
        fetch(
            service.MATERIAL_CATEGORY_URL,
            {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
            })
            .then(res => res.json())
            .then(result => {
                const data2 = result.map((item) => ({ value: item.materialCategoryId, label: item.materialCategory }));
                setMaterialCategoryData(data2);
            });
    };
    const getMaterialSubCategories = (id) => {
        fetch(
            service.MATERIAL_SUB_CATEGORY_URL,
            {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    materialCategoryId: id,
                })
            })
            .then(res => res.json())
            .then(result => {
                const data2 = result.map((item) => ({ value: item.materialSubCategoryId, label: item.materialSubCategory }));
                setMaterialSubCategoryData(data2);
            });
    };
    const getMaterials = (id) => {
        fetch(
            service.MATERIAL_URL,
            {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    materialCategoryId: materialCategoryId.value,
                    materialSubCategoryId: id
                })
            })
            .then(res => res.json())
            .then(result => {
                const data2 = result.map((item) => ({ value: item.materialId, label: item.material }));
                setMaterialData(data2);
            });
    };

    const getProductCategories = () => {
        fetch(
            service.PRODUCT_CATEGORY_URL,
            {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
            })
            .then(res => res.json())
            .then(result => {
                const data2 = result.map((item) => ({ value: item.productCategoryId, label: item.productCategory }));
                setProductCatData(data2);
            });
    };
    const getProductSubCategories = (id) => {
        fetch(
            service.PRODUCT_SUB_CATEGORY_URL,
            {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    ProductCategoryId: id,
                })
            })
            .then(res => res.json())
            .then(result => {
                const data2 = result.map((item) => ({ value: item.productSubCategoryId, label: item.productSubCategory }));
                setProductSubCatData(data2);
            });
    };

    const getProducts = (catId, subCatId) => {
        fetch(
            service.PRODUCT_URL,
            {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    ProductCategoryId: catId,
                    ProductSubCategoryId: subCatId
                })
            })
            .then(res => res.json())
            .then(result => {
                const data2 = result.map((item) => ({ value: item.productId, label: item.product }));
                setProductData(data2);
            });
    };
    const getSubAssemblies = (prodId) => {
        fetch(
            service.SUBASSEMBLY_URL,
            {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    ProductId: prodId
                })
            })
            .then(res => res.json())
            .then(result => {
                const data2 = result.map((item) => ({ value: item.subAssemblyId, label: item.subAssembly }));
                setSubAssemblyData(data2);
            });
    };

    const getParts = (assemblyId) => {
        fetch(
            service.PART_URL,
            {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    SubAssemblyId: assemblyId
                })
            })
            .then(res => res.json())
            .then(result => {
                const data2 = result.map((item) => ({ value: item.partId, label: item.part }));
                setPartData(data2);
            });
    };

    const getCommonParts = () => {
        fetch(
            service.COMMON_PART_URL,
            {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
            })
            .then(res => res.json())
            .then(result => {
                const data2 = result.map((item) => ({ value: item.commonPartId, label: item.part }));
                setCommonPartData(data2);
            });
    };
    const getEmployees = () => {
        fetch(
            service.EMPLOYEE_URL,
            {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
            })
            .then(res => res.json())
            .then(result => {
                const data2 = result.map((item) => ({ value: item.employeeId, label: item.employeeName }));
                setEmployeeData(data2);
                const emp = data2.find((obj) => obj.value === JSON.parse(sessionStorage.getItem('userData')).employeeId);
                setEmployeeId(emp);
            });
    };

    const getSubAssemblyPartMaterial = (subId, parId, commPartId) => {
        fetch(
            service.GET_SUBASSEMBLY_MATERIAL,
            {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    SubAssemblyId: subId,
                    PartId: parId,
                    CommonPartId: commPartId
                })
            })
            .then(res => res.json())
            .then(result => {
                if (result[0].message.messageType === "Failed") {
                    setSubAssemblyMaterialData(null);
                }
                else {
                    setSubAssemblyMaterialData(result);
                }
            })
            .catch(err => {
                if (err) {
                    setErrors(err);
                };
            });
    };

    const getMaterialAvailableQuantity = (id) => {
        setLoading(true);
        fetch(
            service.GET_MATERIAL_AVAILABLE_QUANTITY,
            {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    MaterialId: id,
                })
            })
            .then(res => res.json())
            .then(result => {
                if (result.message.messageType === "Success") {
                    setAvailableQtyData(result);
                }
                else {
                    setAvailableQtyData(null);
                }
            })
            .catch(err => {
                if (err) {
                    setErrors(err);
                };
            });
        setLoading(false);
    };
    // const getMaterialRequisitionByMaterialId = (id) => {
    //     fetch(
    //         service.GET_MATERIAL_REQUISITION_BY_MATERIAL_ID,
    //         {
    //             method: 'POST',
    //             headers: {
    //                 'Accept': 'application/json',
    //                 'Content-Type': 'application/json'
    //             },
    //             body: JSON.stringify({
    //                 MaterialId: id,
    //             })
    //         })
    //         .then(res => res.json())
    //         .then(result => {
    //             setRequisitionData(result);
    //         });
    // };

    const getMaterialRequisitionByEmployeeId = () => {
        fetch(
            service.GET_INTERNAL_MATERIAL_REQUISITION_BY_EMPLOYEE_ID,
            {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    AddedBy: JSON.parse(sessionStorage.getItem('userData')).employeeId,
                })
            })
            .then(res => res.json())
            .then(result => {
                setRequisitionData(result);
            });
    };
    useEffect(() => {
        getCustomers();
        getEmployees();
        getProductCategories();
        getCommonParts();
        getMaterialCategories();
        getMaterialRequisitionByEmployeeId();
    }, []);

    const validate = () => {
        let isValid = true;
        const errs = {};
        if (!issueFor) {
            isValid = false;
            errs[".issueFor"] = "Please select requisition for";
        }
        if (issueFor.value === "Work Order" && !customerId) {
            isValid = false;
            errs[".customer"] = "Please select customer";
        }
        if (issueFor.value === "Work Order" && !workOrderId) {
            isValid = false;
            errs[".workorder"] = "Please select work order";
        }
        if (issueFor.value === "Work Order" && !materialIdForWO) {
            isValid = false;
            errs[".materialIdForWO"] = "Please select material";
        }
        if (issueFor.value === "Office Purpose" && !materialCategoryId) {
            isValid = false;
            errs[".materialCategoryId"] = "Please select material category";
        }
        if (issueFor.value === "Office Purpose" && !materialSubCategoryId) {
            isValid = false;
            errs[".materialSubCategoryId"] = "Please select material sub category";
        }
        if (issueFor.value === "Office Purpose" && !materialId) {
            isValid = false;
            errs[".materialId"] = "Please select material";
        }
        if (!employeeId) {
            isValid = false;
            errs[".employee"] = "Please select requisition by";
        }
        if (!requisitionDate) {
            isValid = false;
            errs[".requisitionDate"] = "Please enter requisition date";
        }
        if (!state.quantity) {
            isValid = false;
            errs[".quantity"] = "Please enter quantity";
        }
        setErrors(errs);
        return isValid;
    }
    const changeHandler = (event) => {
        setState({ ...state, [event.target.name]: event.target.value });
    };
    const handleRadioChange = (stId, prId, subId, ptId, commPartId) => {
        setStockId(stId);
        setProductId(prId);
        setSubAssemblyId(subId);
        setPartId(ptId);
        setCommonPartId(commPartId);
        getSubAssemblyPartMaterial(subId, ptId, commPartId);
    }
    const handleMaterialRadioChange = (mtId) => {
        setMaterialIdForWO(mtId);
        // setRequisitionData(null);
        // getMaterialRequisitionByMaterialId(mtId);
    }
    const issueForChangeHandler = (ev) => {
        setIssueFor(ev);
        setCustomerId(null);
        setWorkOrderId(null);
        setAllocationData([]);
        setSubAssemblyMaterialData([]);
        setMaterialCategoryId(null);
        setMaterialSubCategoryId(null);
        setMaterialId(null);
    }
    const customerChangeHandler = (ev) => {
        setCustomerId(ev);
        setWorkOrderId(null);
        getWorkOrders(ev.value);
    }
    const workOrderChangeHandler = (ev) => {
        setWorkOrderId(ev);
        getStock(ev.value);
    }
    const employeeChangeHandler = (ev) => {
        setEmployeeId(ev);
    }
    const materialCategoryChangeHandler = (ev) => {
        setMaterialCategoryId(ev);
        setMaterialSubCategoryId(null);
        setMaterialId(null);
        getMaterialSubCategories(ev.value);
    }
    const materialSubCategoryChangeHandler = (ev) => {
        setMaterialSubCategoryId(ev);
        // setMaterialId(null);
        getMaterials(ev.value);
    }
    const materialChangeHandler = (ev) => {
        setMaterialId(ev);
        getMaterialAvailableQuantity(ev.value);
        // getMaterialRequisitionByMaterialId(ev.value);
    }

    const productCatChangeHandler = (ev) => {
        setProductCatId(ev);
        setProductSubCatId(null);
        setProductIdForOP(null);
        setSubAssemblyIdForOP(null);
        setPartIdForOP(null);
        setCommonPartIdForOP(null);
        getProductSubCategories(ev.value);
    }
    const productSubCatChangeHandler = (ev) => {
        setProductSubCatId(ev);
        setProductIdForOP(null);
        setSubAssemblyIdForOP(null);
        setPartIdForOP(null);
        setCommonPartIdForOP(null);
        getProducts(productCatId.value, ev.value);
    }
    const productChangeHandler = (ev) => {
        setProductIdForOP(ev);
        setSubAssemblyIdForOP(null);
        setPartIdForOP(null);
        setCommonPartIdForOP(null);
        getSubAssemblies(ev.value);
    }

    const subAssemblyChangeHandler = (ev) => {
        setSubAssemblyIdForOP(ev);
        setPartIdForOP(null);
        setCommonPartIdForOP(null);
        getParts(ev.value);
    }
    const partChangeHandler = (ev) => {
        setPartIdForOP(ev);
    }
    const commonPartChangeHandler = (ev) => {
        setCommonPartIdForOP(ev);
    }
    const submitHandler = e => {
        e.preventDefault();
        let matId = 0;
        let prId = 0;
        let subId = 0;
        let prtId = 0;
        let commPartId = 0;
        const errs = {};
        setLoading(true);
        if (validate()) {
            // eslint-disable-next-line
            if (window.confirm("Are you sure...?")) {
                if (issueFor.value === 'Work Order') {
                    matId = materialIdForWO;
                    prId = productId;
                    subId = subAssemblyId;
                    prtId = partId;
                    commPartId = commonPartId;
                }
                else {
                    matId = materialId.value;
                    prId = productIdForOP ? productIdForOP.value : 0;
                    subId = subAssemblyIdForOP ? subAssemblyIdForOP.value : 0;
                    prtId = partIdForOP ? partIdForOP.value : 0;
                    commPartId = commonPartIdForOP ? commonPartIdForOP.value : 0;
                }
                fetch(
                    service.ADD_INTERNAL_MATERIAL_REQUISITION,
                    {
                        method: 'POST',
                        headers: {
                            'Accept': 'application/json',
                            'Content-Type': 'application/json'
                        },
                        body: JSON.stringify({
                            WorkOrderId: workOrderId ? workOrderId.value : 0,
                            JobNo: workOrderId ? workOrderId.label : 0,
                            ProductId: prId,
                            SubAssemblyId: subId,
                            PartId: prtId,
                            CommonPartId: commPartId,
                            MaterialId: matId,
                            Quantity: state.quantity,
                            RequisitionDate: moment(requisitionDate).format("MM/DD/YYYY"),
                            RequisitionBy: employeeId.value,
                            RequisitionFor: issueFor.value,
                            Remarks: state.remarks,
                            AddedBy: JSON.parse(sessionStorage.getItem('userData')).employeeId,
                            UpdatedBy: JSON.parse(sessionStorage.getItem('userData')).employeeId,
                        })
                    })
                    .then(res => res.json())
                    .then(result => {
                        if (result.messageType === 'Success') {
                            // eslint-disable-next-line
                            alert(result.message);
                            window.location.reload(false);
                            // navigate('/workallocation/workallocation');
                        }
                        else if (result.messageType === 'Failed') {
                            // eslint-disable-next-line
                            alert(result.message);
                            // navigate('/workallocation/workallocation');
                        }
                        else {
                            errs[".invalid"] = result.message;
                            setErrors(errs);
                        }
                    });
            }
        }
        setLoading(false);
    }
    const handleDelete = (id) => {
        setLoading(true);
        // eslint-disable-next-line
        if (window.confirm("Do you want to delete this details?")) {
            fetch(
                service.DELETE_INTERNAL_MATERIAL_REQUISITION,
                {
                    method: 'POST',
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        RequisitionId: id
                    })
                })
                .then(res => res.json())
                .then(result => {
                    if (result.messageType === 'Success') {
                        // eslint-disable-next-line
                        alert(result.message);
                    }
                    else if (result.messageType === 'Failed') {
                        // eslint-disable-next-line
                        alert(result.message);
                    }
                    else {
                        // eslint-disable-next-line
                        alert(result.message);
                    }
                });
            setRequisitionData(null);
            window.location.reload(false);
        }
        setLoading(false);
    }

    const searchHandler = () => {
        setLoading(true);
        if (state.search !== "") {
            fetch(
                service.GET_MATERIAL_BY_SEARCH,
                {
                    method: 'POST',
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        Material: state.search
                    })
                })
                .then(res => res.json())
                .then(result => {
                    setState({ ...state, materials: result.material });
                });
        }
        setLoading(false);
    }

    return (
        <DashboardLayout>
            <DashboardNavbar />
            <MDBox pt={6} pb={3}>
                <Grid container spacing={6}>
                    <Grid item xs={12}>
                        <Card>
                            <MDBox
                                mx={2}
                                mt={-3}
                                py={3}
                                px={2}
                                variant="gradient"
                                bgColor="info"
                                borderRadius="lg"
                                coloredShadow="info"
                            >
                                <MDTypography variant="h6" color="white">
                                    Save Details
                                </MDTypography>
                            </MDBox>
                            <Card style={{ alignItems: 'center' }}>
                                <br />
                                <Table>
                                    <TableBody>
                                        <TableRow>
                                            <TableCell>
                                                <MDInput label="Search Material" fullWidth value={state.search || ''}
                                                    name="search"
                                                    onChange={changeHandler}
                                                    id="search"
                                                />
                                                <div style={{ fontSize: '12px', color: 'red' }}>{errors[".search"]}</div>
                                            </TableCell>
                                            <TableCell>
                                                <MDButton color="info" onClick={searchHandler}>
                                                    SEARCH
                                                </MDButton>
                                            </TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell colSpan="2"><div style={{ fontSize: '14px', color: 'green', fontWeight: 'bold' }}>{state.materials || ''}</div></TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell>
                                                <div style={{ fontSize: '12px' }}>
                                                    <Select
                                                        options={issueForData}
                                                        name="issueFor"
                                                        value={issueFor}
                                                        onChange={issueForChangeHandler}
                                                        placeholder="Select For"
                                                        isSearchable
                                                        styles={selectStyles}
                                                    />
                                                    <div style={{ fontSize: '12px', color: 'red' }}>{errors[".issueFor"]}</div>
                                                </div>
                                            </TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell align='left' style={{ fontSize: '12px', width: '30%' }}>
                                                <Select
                                                    options={customerData}
                                                    name="customer"
                                                    value={customerId}
                                                    onChange={customerChangeHandler}
                                                    placeholder="Select Customer"
                                                    isSearchable
                                                    styles={selectStyles}
                                                    isDisabled={issueFor.value === 'Office Purpose'}
                                                />
                                                <div style={{ fontSize: '12px', color: 'red' }}>{errors[".customer"]}</div>
                                            </TableCell>
                                            <TableCell align='left' style={{ fontSize: '12px', width: '30%' }}>
                                                <Select
                                                    options={workOrderData}
                                                    name="workorder"
                                                    value={workOrderId}
                                                    onChange={workOrderChangeHandler}
                                                    placeholder="Select Job Number"
                                                    isSearchable
                                                    styles={selectStyles}
                                                    isDisabled={issueFor.value === 'Office Purpose'}
                                                />
                                                <div style={{ fontSize: '12px', color: 'red' }}>{errors[".workorder"]}</div>
                                            </TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell colSpan={3} align='center'>
                                                {loading ? <Oval
                                                    heigth="100"
                                                    width="100"
                                                    color='grey'
                                                    ariaLabel='loading'
                                                /> :
                                                    <TableContainer component={Paper} style={{ width: '95%', alignSelf: 'center', }}>
                                                        <Table aria-label="simple table">
                                                            <TableRow>
                                                                <TableCell style={{ fontWeight: 'bold' }}>Select</TableCell>
                                                                <TableCell style={{ fontWeight: 'bold' }}>Product</TableCell>
                                                                <TableCell style={{ fontWeight: 'bold' }}>Sub Assembly</TableCell>
                                                                <TableCell style={{ fontWeight: 'bold' }}>Part</TableCell>
                                                                <TableCell style={{ fontWeight: 'bold' }}>Common Part</TableCell>
                                                                <TableCell style={{ fontWeight: 'bold' }}>Stock Number</TableCell>
                                                            </TableRow>

                                                            <TableBody>
                                                                {allocationData.map((row) => (
                                                                    <TableRow
                                                                        key={row.stockId}
                                                                        sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                                                    >
                                                                        <TableCell><Radio onChange={() => handleRadioChange(row.stockId, row.productId, row.subAssemblyId, row.partId)}
                                                                            value={row.stockId} name="radio-buttons"
                                                                            checked={stockId === row.stockId} />
                                                                        </TableCell>
                                                                        <TableCell>{row.product}</TableCell>
                                                                        <TableCell>{row.subAssembly}</TableCell>
                                                                        <TableCell>{row.part}</TableCell>
                                                                        <TableCell>{row.commonPart}</TableCell>
                                                                        <TableCell>{row.stockNumber}</TableCell>
                                                                    </TableRow>
                                                                ))}
                                                            </TableBody>
                                                        </Table>
                                                        <div style={{ fontSize: '12px', color: 'red' }}>{errors[".stockId"]}</div>
                                                    </TableContainer>
                                                }
                                            </TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell colSpan={3} align='center'>
                                                {loading ? <Oval
                                                    heigth="100"
                                                    width="100"
                                                    color='grey'
                                                    ariaLabel='loading'
                                                /> :
                                                    <TableContainer component={Paper} style={{ width: '95%', alignSelf: 'center', }}>
                                                        <Table aria-label="simple table">
                                                            <TableRow>
                                                                <TableCell style={{ fontWeight: 'bold' }}>Select</TableCell>
                                                                <TableCell style={{ fontWeight: 'bold' }}>Material Category</TableCell>
                                                                <TableCell style={{ fontWeight: 'bold' }}>Material Sub Category</TableCell>
                                                                <TableCell style={{ fontWeight: 'bold' }}>Material</TableCell>
                                                                <TableCell style={{ fontWeight: 'bold' }}>Required Quantity</TableCell>
                                                                <TableCell style={{ fontWeight: 'bold' }}>Available Quantity</TableCell>
                                                            </TableRow>
                                                            {subAssemblyMaterialData ?
                                                                <TableBody>
                                                                    {subAssemblyMaterialData.map((row) => (
                                                                        <TableRow
                                                                            key={row.materialId}
                                                                            sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                                                        >
                                                                            <TableCell><Radio onChange={() => handleMaterialRadioChange(row.materialId)}
                                                                                value={row.materialId} name="radio-buttons"
                                                                                checked={materialIdForWO === row.materialId} />
                                                                            </TableCell>
                                                                            <TableCell>{row.materialCategory}</TableCell>
                                                                            <TableCell>{row.materialSubCategory}</TableCell>
                                                                            <TableCell>{row.material}</TableCell>
                                                                            <TableCell>{row.quantity}</TableCell>
                                                                            <TableCell>{row.availableQuantity}</TableCell>
                                                                        </TableRow>
                                                                    ))}
                                                                </TableBody>
                                                                : null}
                                                        </Table>
                                                        <div style={{ fontSize: '12px', color: 'red' }}>{errors[".materialIdForWO"]}</div>
                                                    </TableContainer>
                                                }
                                            </TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell align='left' style={{ fontSize: '12px' }}>
                                                <Select
                                                    name="productCategory"
                                                    options={productCatData} placeholder="Select Product Category"
                                                    value={productCatId}
                                                    onChange={productCatChangeHandler}
                                                    isSearchable
                                                    styles={selectStyles}
                                                    isDisabled={issueFor.value === 'Work Order'}
                                                />
                                                <div style={{ fontSize: '12px', color: 'red' }}>{errors[".productcategory"]}</div>
                                            </TableCell>
                                            <TableCell align='left' style={{ fontSize: '12px' }}>
                                                <Select
                                                    name="productSubCategory"
                                                    options={productSubCatData} placeholder="Select Product Sub Category"
                                                    value={productSubCatId}
                                                    onChange={productSubCatChangeHandler}
                                                    isSearchable
                                                    styles={selectStyles}
                                                    isDisabled={issueFor.value === 'Work Order'}
                                                />
                                                <div style={{ fontSize: '12px', color: 'red' }}>{errors[".productsubcategory"]}</div>
                                            </TableCell>
                                            <TableCell align='left' style={{ fontSize: '12px' }}>
                                                <Select
                                                    name="product"
                                                    options={productData} placeholder="Select Product"
                                                    value={productIdForOP}
                                                    onChange={productChangeHandler}
                                                    isSearchable
                                                    styles={selectStyles}
                                                    isDisabled={issueFor.value === 'Work Order'}
                                                />
                                                <div style={{ fontSize: '12px', color: 'red' }}>{errors[".product"]}</div>
                                            </TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell align='left' style={{ fontSize: '12px' }}>
                                                <Select
                                                    name="subassembly"
                                                    options={subAssemblyData} placeholder="Select Sub Assembly"
                                                    value={subAssemblyIdForOP}
                                                    onChange={subAssemblyChangeHandler}
                                                    isSearchable
                                                    styles={selectStyles}
                                                    isDisabled={issueFor.value === 'Work Order'}
                                                />
                                                <div style={{ fontSize: '12px', color: 'red' }}>{errors[".subassembly"]}</div>
                                            </TableCell>
                                            <TableCell align='left' style={{ fontSize: '12px' }}>
                                                <Select
                                                    name="part"
                                                    options={partData} placeholder="Select Part"
                                                    value={partIdForOP}
                                                    onChange={partChangeHandler}
                                                    isSearchable
                                                    styles={selectStyles}
                                                    isDisabled={issueFor.value === 'Work Order'}
                                                />
                                                <div style={{ fontSize: '12px', color: 'red' }}>{errors[".part"]}</div>
                                            </TableCell>
                                            <TableCell align='left' style={{ fontSize: '12px' }}>
                                                <Select
                                                    name="commonpart"
                                                    options={commonPartData} placeholder="Select Common Part"
                                                    value={commonPartIdForOP}
                                                    onChange={commonPartChangeHandler}
                                                    isSearchable
                                                    styles={selectStyles}
                                                    isDisabled={issueFor.value === 'Work Order'}
                                                />
                                                <div style={{ fontSize: '12px', color: 'red' }}>{errors[".commonpart"]}</div>
                                            </TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell align='left' style={{ fontSize: '12px', width: '30%' }}>
                                                <Select
                                                    options={materialCategoryData}
                                                    name="materialCategory"
                                                    value={materialCategoryId}
                                                    onChange={materialCategoryChangeHandler}
                                                    placeholder="Select Material Category"
                                                    isSearchable
                                                    styles={selectStyles}
                                                    isDisabled={issueFor.value === 'Work Order'}
                                                />
                                                <div style={{ fontSize: '12px', color: 'red' }}>{errors[".materialCategoryId"]}</div>
                                            </TableCell>
                                            <TableCell align='left' style={{ fontSize: '12px', width: '30%' }}>
                                                <Select
                                                    options={materialSubCategoryData}
                                                    name="materialSubCategory"
                                                    value={materialSubCategoryId}
                                                    onChange={materialSubCategoryChangeHandler}
                                                    placeholder="Select Material Sub Category"
                                                    isSearchable
                                                    styles={selectStyles}
                                                    isDisabled={issueFor.value === 'Work Order'}
                                                />
                                                <div style={{ fontSize: '12px', color: 'red' }}>{errors[".materialSubCategoryId"]}</div>
                                            </TableCell>
                                            <TableCell align='left' style={{ fontSize: '12px', width: '30%' }}>
                                                <Select
                                                    options={materialData}
                                                    name="material"
                                                    value={materialId}
                                                    onChange={materialChangeHandler}
                                                    placeholder="Select Material"
                                                    isSearchable
                                                    styles={selectStyles}
                                                    isDisabled={issueFor.value === 'Work Order'}
                                                />
                                                <div style={{ fontSize: '12px', color: 'red' }}>{errors[".materialId"]}</div>
                                            </TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell>
                                                {issueFor.value === 'Office Purpose' ?
                                                    <div>Available Quantity:
                                                        {loading ? <Oval
                                                            heigth="100"
                                                            width="100"
                                                            color='grey'
                                                            ariaLabel='loading'
                                                        /> :
                                                            <div>
                                                                {availableQtyData.availableQuantity} </div>} </div>
                                                    : null}
                                            </TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell>
                                                <MDInput label="Quantity" fullWidth value={state.quantity || ''}
                                                    name="quantity"
                                                    onChange={changeHandler}
                                                    id="quantity"
                                                    required
                                                />
                                                <div style={{ fontSize: '12px', color: 'red' }}>{errors[".quantity"]}</div>
                                            </TableCell>
                                            <TableCell>
                                                <MDBox mb={2} style={{ fontSize: '14px' }}>
                                                    <Select
                                                        options={employeeData}
                                                        name="employee"
                                                        value={employeeId}
                                                        onChange={employeeChangeHandler}
                                                        isSearchable
                                                        isDisabled
                                                        styles={selectStyles}
                                                    />
                                                    <div style={{ fontSize: '12px', color: 'red' }}>{errors[".employee"]}</div>
                                                </MDBox>
                                            </TableCell>
                                            <TableCell>
                                                Requisition Date
                                                <DatePicker
                                                    id="requisitionDate"
                                                    selected={requisitionDate}
                                                    onChange={date => setRequisitionDate(date)}
                                                    dateFormat="MM/dd/yyyy"
                                                    tabIndex={0}
                                                />
                                            </TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell>
                                                <MDInput label="Remarks" fullWidth value={state.remarks || ''}
                                                    name="remarks"
                                                    onChange={changeHandler}
                                                    id="remarks"
                                                    required
                                                    multiline
                                                />
                                                <div style={{ fontSize: '12px', color: 'red' }}>{errors[".remarks"]}</div>
                                            </TableCell>
                                        </TableRow>
                                    </TableBody>
                                </Table>
                                <MDBox mt={4} mb={1} textAlign="center">
                                    {loading ? <Oval
                                        heigth="20"
                                        width="20"
                                        color='grey'
                                        ariaLabel='loading'
                                    /> :
                                        <MDButton color="info" onClick={submitHandler}>
                                            SAVE
                                        </MDButton>
                                    }
                                    {errors ? <div style={{ fontSize: '12px', color: 'red' }}>{errors[".invalid"]}</div> : null}
                                </MDBox>
                            </Card>
                            {requisitionData ?
                                <Card style={{ alignItems: 'center' }}>
                                    <div style={{ fontSize: '16px', fontWeight: 'bold', width: '100%', backgroundColor: 'lightgray' }} align="center">
                                        Internal Material Requisition Details
                                    </div>
                                    <TableContainer component={Paper} style={{ width: '90%', alignSelf: 'center', }}>
                                        <Table aria-label="simple table">
                                            <TableRow>
                                                <TableCell style={{ fontWeight: 'bold' }}>Material</TableCell>
                                                <TableCell style={{ fontWeight: 'bold' }}>Material Code</TableCell>
                                                <TableCell style={{ fontWeight: 'bold' }}>Requisition Date</TableCell>
                                                <TableCell style={{ fontWeight: 'bold' }}>Quantity</TableCell>
                                                <TableCell style={{ fontWeight: 'bold' }}>Requisition By</TableCell>
                                                <TableCell style={{ fontWeight: 'bold' }}>Requisition For</TableCell>
                                                <TableCell style={{ fontWeight: 'bold' }}>Job No</TableCell>
                                                <TableCell style={{ fontWeight: 'bold' }}>Status</TableCell>
                                                <TableCell style={{ fontWeight: 'bold' }}>Remarks</TableCell>
                                                <TableCell style={{ fontWeight: 'bold' }}>Action</TableCell>
                                            </TableRow>
                                            <TableBody>
                                                {requisitionData.map((row) => (
                                                    <TableRow
                                                        key={row.requisitionId}
                                                        sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                                    >
                                                        <TableCell>{row.material}</TableCell>
                                                        <TableCell>{row.materialCode}</TableCell>
                                                        <TableCell>{moment(row.requisitionDate).format("DD/MM/YYYY")}</TableCell>
                                                        <TableCell>{row.quantity}</TableCell>
                                                        <TableCell>{row.requisitionByName}</TableCell>
                                                        <TableCell>{row.requisitionFor}</TableCell>
                                                        <TableCell>{row.jobNo}</TableCell>
                                                        <TableCell>{row.status}</TableCell>
                                                        <TableCell>{row.remarks}</TableCell>
                                                        <TableCell>{row.status === 'Pending' ? <MDButton onClick={() => handleDelete(row.requisitionId)}>Delete</MDButton> : null}</TableCell>
                                                    </TableRow>
                                                ))}
                                            </TableBody>
                                        </Table>
                                    </TableContainer>
                                </Card>
                                : null}
                        </Card>
                    </Grid>
                </Grid>
            </MDBox>
            <Footer />
        </DashboardLayout>
    );
}

export default InternalMaterialRequisitions;